import { getIdToken } from "./firebaseAuth";

/**
 * Attaches a Firebase ID token Authorization header to an outgoing /api/**
 * request when a user is signed in. A no-op (returns headers unchanged) when
 * auth is disabled or nobody is signed in yet, so every existing call site
 * keeps working locally without any auth setup.
 */
export async function withAuthHeaders(headers?: HeadersInit): Promise<Headers> {
  const merged = new Headers(headers);
  const token = await getIdToken();

  if (token) {
    merged.set("authorization", `Bearer ${token}`);
  }

  return merged;
}
